import { Component, Input } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { SharedModule } from '../../../../shared/shared.module';
import { SelectKkmTariffNavigationService } from '../select-kkm-tariff-navigation.service';
import { TariffsModule } from '../../../tariffs/tariffs.module';
import { Tariff } from '../../../tariffs/tariff.model';
import { TariffFormModel } from '../../../tariffs/select-tariff-connection/select-tariff-connection.types';
import { TariffService } from '../../../../core/services/tariff.service';
import { SelectTariffProcessFields } from '../../sign-selected-tariff-page/sign-selected-tariff-page.model';

@UntilDestroy()
@Component({
  selector: 'tax-kkm-tariff-form',
  templateUrl: './select-kkm-tariff-form.component.html',
  styleUrls: ['./select-kkm-tariff-form.component.sass'],
  standalone: true,
  imports: [
    SharedModule,
    TariffsModule,
  ],
})

export class SelectKkmTariffFormComponent {
  @Input() selectedTariff?: Tariff;
  @Input() kkmProcessFields?: SelectTariffProcessFields;
  @Input() selectedTariffsRange: Tariff[] = [];
  @Input() kkmId: number | null = null;

  tariffForm?: FormGroup<TariffFormModel>;
  constructor(
    private selectedKkmTariffNavigationService: SelectKkmTariffNavigationService,
    private tariffService: TariffService,
  ) {}

  updateFormState(tariffForm: FormGroup<TariffFormModel>): void {
    if (!tariffForm.value.connectionType) return;
    this.tariffForm = tariffForm;
    this.selectedTariff = this.tariffService.getTariffsByParams(this.selectedTariffsRange, {
      connectionType: tariffForm.value.connectionType,
    })[0];
  }

  goToSignPage(): void {
    if (!this.kkmId || !this.selectedTariff) return;

    this.selectedKkmTariffNavigationService.navigateToSignPage(
      this.kkmId,
      this.selectedTariff,
      this.tariffForm?.getRawValue(),
    ).pipe(
      untilDestroyed(this),
    )
      .subscribe();
  }

  back(): void {
    this.selectedKkmTariffNavigationService.resetBpStep();
    this.selectedTariff = undefined;
  }
}
